import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
// GeneralViews
import Login from "@/pages/Login.vue";
import Settings from "@/pages/Settings.vue";
import Dashboard from "@/pages/Dashboard.vue";
import SystemRuns from "@/pages/SystemRuns.vue";
import CommandDetails from "@/pages/CommandDetails.vue";
import FoundGames from "@/pages/FoundGames.vue";

const Matches = () => import(/* webpackChunkName: "matches" */ "@/pages/Matches.vue");

const routes = [
  {
    path: "/login",
    component: Login,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/football",
    children: [
      {
        path: "dashboard",
        name: "dashboard",
        component: Dashboard,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "system-runs",
        name: "system-runs",
        component: SystemRuns,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "command-details/:commandName",
        name: "CommandDetails",
        component: CommandDetails,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "football",
        name: "football",
        component: Matches,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "basketball",
        name: "basketball",
        component: Matches,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "volleyball",
        name: "volleyball",
        component: Matches,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "handball",
        name: "handball",
        component: Matches,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "ice-hockey",
        name: "hockey",
        component: Matches,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "rugby",
        name: "rugby",
        component: Matches,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "baseball",
        name: "baseball",
        component: Matches,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "american-football",
        name: "american-football",
        component: Matches,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "floorball",
        name: "floorball",
        component: Matches,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "futsal",
        name: "futsal",
        component: Matches,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "bandy",
        name: "bandy",
        component: Matches,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "water-polo",
        name: "water-polo",
        component: Matches,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "found-games",
        name: "found-games",
        component: FoundGames,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "settings",
        name: "settings",
        component: Settings,
        meta: {
          requiresAuth: true
        }
      }
    ]
  },
  {
    path: "*",
    component: Login,
    meta: {
      requiresAuth: false
    }
  }
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
